import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7144
 *
 * @param {SvgIconProps} props - svg props
 */
export const FullscreenExitIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M10 4H8.825C8.54886 4 8.325 4.22386 8.325 4.5V8.33333H3.75C3.47386 8.33333 3.25 8.55719 3.25 8.83333V10C3.25 10.2761 3.47386 10.5 3.75 10.5H10.25C10.3881 10.5 10.5 10.3881 10.5 10.25V4.5C10.5 4.22386 10.2761 4 10 4ZM15.175 4H14C13.7239 4 13.5 4.22386 13.5 4.5V10.25C13.5 10.3881 13.6119 10.5 13.75 10.5H20.25C20.5261 10.5 20.75 10.2761 20.75 10V8.83333C20.75 8.55719 20.5261 8.33333 20.25 8.33333H15.675V4.5C15.675 4.22386 15.4511 4 15.175 4ZM15.175 20H14C13.7239 20 13.5 19.7761 13.5 19.5V13.75C13.5 13.6119 13.6119 13.5 13.75 13.5H20.25C20.5261 13.5 20.75 13.7239 20.75 14V15.1667C20.75 15.4428 20.5261 15.6667 20.25 15.6667H15.675V19.5C15.675 19.7761 15.4511 20 15.175 20ZM8.825 20H10C10.2761 20 10.5 19.7761 10.5 19.5V13.75C10.5 13.6119 10.3881 13.5 10.25 13.5H3.75C3.47386 13.5 3.25 13.7239 3.25 14V15.1667C3.25 15.4428 3.47386 15.6667 3.75 15.6667H8.325V19.5C8.325 19.7761 8.54886 20 8.825 20Z' fill={color}/>
        </SvgIcon>
    )
}

export default FullscreenExitIcon
